import React from 'react';
import { Header } from '../components/Header';
import { BalanceTransferCalculator } from '../components/BalanceTransferCalculator';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { CalcBreadcrumb, CalcRelatedLinks } from '../components/CalcBreadcrumb';

const BalanceTransferCalculatorPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <WhatsAppButton />
      
      <div className="bg-white pt-24 sm:pt-28 md:pt-32 pb-10 sm:pb-12">
        <div className="container mx-auto px-4">
          <CalcBreadcrumb name="Balance Transfer Calculator" path="/calculators/balance-transfer" />
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-3 sm:mb-4 text-center leading-[1.1]">
            Balance Transfer <span className="text-emerald-600">Calculator</span>
          </h1>
          <p className="text-base sm:text-lg text-slate-600 text-center max-w-2xl mx-auto">
            Compare savings from switching to a lower interest rate
          </p>
          <CalcRelatedLinks links={[['Home Loan', '/home-loan'], ['Balance Transfer with Top-Up', '/balance-transfer-with-topup']]} />
        </div>
      </div>

      <BalanceTransferCalculator />
      <Footer />
    </div>
  );
};

export default BalanceTransferCalculatorPage;
